import { Observable } from "rxjs/Observable";
import * as actions from "./job-type.actions";
import { JobType } from "./job-type.model";
import { CategoryStoreFacade } from "../category/category.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class JobTypeStoreFacade extends CategoryStoreFacade<JobType> {

    getAll(): Observable<Array<JobType>> {
        return this.select(Qry.getInstance().jobType.byActiveAccount);
    }

    getForAllAccounts(): Observable<Array<JobType>> {
        return this.select(Qry.getInstance().jobType.items);
    }

    getFiltered(): Observable<Array<JobType>> {
        return this.select(Qry.getInstance().jobType.filtered);
    }

    create(jobType: JobType): void {
        this.dispatch(new actions.SubmitAction(jobType));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachJobType(membership, jobType, {restful: false, persistable: true});
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    update(jobType: JobType): void {
        this.dispatch(new actions.SubmitAction(jobType));
    }

    insert(jobType: JobType): void {
        this.dispatch(new actions.SubmitAction(jobType, {persistable: true, restful: false}));
    }

    remove(jobType: JobType, options?: ActionOptionsArgs): void {
        this.appFacade.objects.job.store.removeByJobType(jobType, options);

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachJobType(membership, jobType, {restful: false, persistable: true});
        });

        this.dispatch(new actions.RemoveAction(jobType, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    setFilters(filters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    canDelete(jobType: JobType): Observable<boolean> {
        return this.checkHasDependency(this.appFacade.objects.job.store, jobType, "Jobs")
            .switchMap(() => super.canDelete(jobType));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.store-facade.ts